<div class="accordion" id="accordionExample" style="margin-top: -25px;">
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading0">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse0" aria-expanded="false" aria-controls="collapse0">
                Ingangsdatum & Einddatum
            </button>
        </h2>
        <div id="collapse0" class="accordion-collapse collapse" aria-labelledby="heading0"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Bij de ingangs- en einddatum gaat het om de datums vanhet dienstverband. Vul hier dezelfde data in als
                bij het tabblad 'Dienstverband;.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading1">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse1" aria-expanded="false" aria-controls="collapse1">
                WAO verzekerd
            </button>
        </h2>
        <div id="collapse1" class="accordion-collapse collapse" aria-labelledby="heading1"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                <b>WAO - Wet op de Arbeidsongeschiktheidsverzekering</b>
                <br/><br/>

                <p><strong>Wat is de WAO?</strong><br>
                    De WAO is vervangen door de WIA (Wet Werk en Inkomen naar Arbeidsvermogen) sinds 2006. Maar de term
                    WAO wordt nog steeds vaak gebruikt. Deze verzekering biedt je inkomen als je door ziekte of een
                    ongeval langdurig arbeidsongeschikt raakt.</p>

                <p><strong>Ben je verzekerd?</strong><br>
                    Je bent automatisch verzekerd voor de WIA/WAO als:</p>
                <ul>
                    <li>Je in Nederland woont of werkt</li>
                    <li>Je tussen de 15 en 65 jaar bent</li>
                    <li>Je werknemer bent (in loondienst)</li>
                    <li>Je premies betaalt via je werkgever</li>
                </ul>

                <p><strong>Wanneer ben je NIET verzekerd?</strong><br>
                    Je bent niet verzekerd als je:</p>
                <ul>
                    <li>Zelfstandige bent zonder personeel (zzp'er)</li>
                    <li>Directeur-grootaandeelhouder (DGA) bent</li>
                    <li>Werkt met een uitzondering (zoals sommige buitenlandse werknemers)</li>
                </ul>
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading2">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse2" aria-expanded="false" aria-controls="collapse2">
                WW verzekerd
            </button>
        </h2>
        <div id="collapse2" class="accordion-collapse collapse" aria-labelledby="heading2"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                <b>WW - Werkloosheidswet</b>
                <br/><br/>

                <p><strong>Wat is de WW?</strong><br>
                    De WW geeft je recht op een uitkering als je werkloos wordt. Dit helpt je financieel over de brug
                    totdat je nieuw werk vindt.</p>

                <p><strong>Ben je verzekerd?</strong><br>
                    Je bent automatisch verzekerd voor de WW als:</p>
                <ul>
                    <li>Je in Nederland woont</li>
                    <li>Je tussen de 15 en 65 jaar bent</li>
                    <li>Je werknemer bent (in loondienst)</li>
                    <li>Je minstens 26 weken in de 36 weken vóór je werkloosheid hebt gewerkt</li>
                </ul>

                <p><strong>Wanneer ben je NIET verzekerd?</strong><br>
                    Je bent niet verzekerd als je:</p>
                <ul>
                    <li>Zelfstandige bent (zzp'er)</li>
                    <li>Directeur-grootaandeelhouder (DGA) bent</li>
                    <li>Een uitkering hebt (zoals AOW, WAO/WIA)</li>
                    <li>Minder dan 5 uur per week werkt</li>
                </ul>

            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading3">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse3" aria-expanded="false" aria-controls="collapse3">
                ZW verzekerd
            </button>
        </h2>
        <div id="collapse3" class="accordion-collapse collapse" aria-labelledby="heading3"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                <b>ZW - Ziektewet</b>
                <br/><br/>

                <p><strong>Wat is de ZW?</strong><br>
                    De Ziektewet zorgt ervoor dat je tijdens ziekte (gedeeltelijk) loon blijft ontvangen. Voor de meeste
                    werknemers betaalt de werkgever dit de eerste 2 jaar door (Wet Verbetering Poortwachter).</p>

                <p><strong>Ben je verzekerd?</strong><br>
                    Je bent automatisch verzekerd voor de ZW als:</p>
                <ul>
                    <li>Je in Nederland woont of werkt</li>
                    <li>Je jonger bent dan 65 jaar</li>
                    <li>Je werknemer bent (in loondienst)</li>
                    <li>Je meer verdient dan het minimumloon op jaarbasis</li>
                </ul>

                <p><strong>Wanneer ben je NIET verzekerd?</strong><br>
                    Je bent niet verzekerd als je:</p>
                <ul>
                    <li>Zelfstandige bent (zzp'er) - tenzij je je vrijwillig verzekert</li>
                    <li>Directeur-grootaandeelhouder (DGA) bent</li>
                    <li>Minder verdient dan het minimumloon op jaarbasis</li>
                    <li>Werkt met een specifieke uitzondering</li>
                </ul>
            </div>
        </div>
    </div>
</div>

